import { render, staticRenderFns } from "./OTPVerificationCodeModal.vue?vue&type=template&id=fd3440da&scoped=true&"
import script from "./OTPVerificationCodeModal.vue?vue&type=script&lang=js&"
export * from "./OTPVerificationCodeModal.vue?vue&type=script&lang=js&"
import style0 from "./OTPVerificationCodeModal.vue?vue&type=style&index=0&id=fd3440da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3440da",
  null
  
)

export default component.exports